import { useLocation } from "preact-iso/router";

interface Props {
  onOpenSettings: () => void;
}

/** Mobile-only bottom navigation. Hidden on desktop (>= 700px) via CSS. */
export function BottomNav({ onOpenSettings }: Props) {
  const location = useLocation();
  const path = location.path || "/";

  const items: { href: string; label: string; icon: string; active: boolean }[] = [
    { href: "/jobs", label: "Jobs", icon: "📋", active: path === "/jobs" || path === "/" },
    { href: "/pipeline", label: "Pipeline", icon: "🗂️", active: path === "/pipeline" },
  ];

  return (
    <nav class="bottom-nav" aria-label="Mobile navigation">
      {items.map((item) => (
        <a
          href={item.href}
          class={`bottom-nav-item${item.active ? " active" : ""}`}
          aria-current={item.active ? "page" : undefined}
        >
          <span class="bottom-nav-icon" aria-hidden="true">{item.icon}</span>
          <span class="bottom-nav-label">{item.label}</span>
        </a>
      ))}
      <button type="button" class="bottom-nav-item" onClick={onOpenSettings} aria-label="Settings">
        <span class="bottom-nav-icon" aria-hidden="true">⚙️</span>
        <span class="bottom-nav-label">Settings</span>
      </button>
    </nav>
  );
}
